/**
 * Modal
 */
import clsx from 'clsx';
import React from 'react';
import AriaModal from 'react-aria-modal';
import Icon from '../Icon';
/** Main description for this component. */
var Modal = function (_a) {
    var onToggle = _a.onToggle, closeBtnLabel = _a.closeBtnLabel, children = _a.children, className = _a.className;
    return (React.createElement(AriaModal, { onExit: onToggle, titleText: "Modal", underlayClickExits: true, focusDialog: true, verticallyCenter: true, underlayClass: "react-aria-modal__underlay", dialogClass: "inline-block text-left top-0 max-w-full cursor-default outline-none align-middle", includeDefaultStyles: false },
        React.createElement("div", { className: "relative bg-white rounded-lg m-2" },
            React.createElement("div", { className: clsx('md:pt-6', 'md:px-8', 'md:pb-8', 'p-4', className) },
                React.createElement("button", { "aria-label": closeBtnLabel, onClick: function (e) {
                        e.preventDefault();
                        onToggle();
                    }, className: "group absolute top-0 right-0 mt-4 mr-4 md:mt-8 md:mr-8" },
                    React.createElement(Icon, { icon: "close", size: 2 })),
                children))));
};
export default Modal;
